import React, {useEffect, useRef, useState} from 'react';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Form, message} from 'antd';
import {ResponseStatus} from '@/utils/request';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Product} from '@/services/mdm/product';
import {ProFormInstance} from '@ant-design/pro-form';
import {FieldProps, wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {FieldConfig, getEcFieldsValue} from '@/components/WdiBus/EcFieldConfig';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {FormSa} from '@/services/sales/sa';
import {getDetailPrevData, paymentMethodDataLoading} from '../../components/data';
import {max} from 'lodash';
import moment from 'moment';
import {
  PRODUCT_FULL_LEVELS, ecFields,
  buildFormItem, buildEcFormItem, getEcProductConfig, convertEcFieldConfigs, isNeedProductFg, showCompany,
} from "@/pages/sales/sa/GeneralActivityApply/components/DetailBase";
import {Company} from "@/services/mdm/company";
import {SoldTo} from "@/services/mdm/soldto";

const DetailPosRevenueApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [ecFieldConfigs, setEcFieldConfigs] = useState<Record<string, FieldConfig>>();
  const [pmOpts, setPmOpts] = useState<any[]>();
  const [expandKeysProduct, setExpandKeysProduct] = useState<string[]>();
  const [productConfig, setProductConfig] = useState<{ levels: number[], fieldCfg: FieldConfig }>();
  const [paymentMethodId, setPaymentMethodId] = useState(0);
  const [productBuyIds, setProductBuyIds] = useState<string>();

  const {formSaDetail, formSa, rowIndex, rows} = props.data;

  const handlePaymentMethodChange = (value: number) => {
    if (wdiCore.Object.IsNullOrUndefined(value)) {
      setPaymentMethodId(0);
    } else {
      setPaymentMethodId(value);
      if (showCompany(value)) {
        const companyCodeVal = formRef.current?.getFieldValue("companyCode");
        if (!companyCodeVal) {
          SoldTo.get(formSaDetail.soldToCode).then(resp => {
            formRef.current?.setFieldsValue({companyCode: resp.data.companyCode});
          });
        }
      }
    }
  }

  useEffect(() => {
    if (formSaDetail) {
      formRef.current?.setFieldsValue({
        formSaDetailIdOriginal: formSaDetail.formSaDetailIdOriginal,
        paymentMethodId: formSaDetail.paymentMethodId,
        amount: formSaDetail.amount,
        roiForecast: formSaDetail.roiForecast,
        boName: formSaDetail.boName,
        ecName: formSaDetail.ecName,
        revenueTypeName: formSaDetail.revenueTypeName,
        companyCode: formSaDetail.companyCode,
        soldToName: wdiCore.String.Join(formSaDetail.soldToCode, formSaDetail.soldToName),
        remark: formSaDetail.remark
      });
      handlePaymentMethodChange(formSaDetail.paymentMethodId);

      if (formSaDetail.activityStartDate) {
        formRef.current?.setFieldsValue({
          activityDate: [
            moment(formSaDetail.activityStartDate),
            moment(formSaDetail.activityEndDate),
          ]
        });
      }

      if (formSaDetail.supplyStartDate) {
        formRef.current?.setFieldsValue({
          supplyDate: [
            moment(formSaDetail.supplyStartDate),
            moment(formSaDetail.supplyEndDate),
          ]
        });
      }

      //支付方式根据所选的费用项和售达方类型构造，若只有一个支付方式自动埴入
      if (formSaDetail.ecId) {
        paymentMethodDataLoading(formSaDetail.ecId).then(paymentMethods => {
          setPmOpts(paymentMethods.map((item) => {
            return {value: item.value, label: item.name};
          }));
          if (paymentMethods.length === 1) {
            formRef.current?.setFieldsValue({paymentMethodId: paymentMethods[0].value});
            handlePaymentMethodChange(paymentMethods[0].value);
          }
        });
      }

      if (formSaDetail.extendFieldsSa || formSaDetail.revExtendFieldsSa) {
        convertEcFieldConfigs(formSaDetail.extendFieldsSa, formSaDetail.revExtendFieldsSa).then(response => {
          setEcFieldConfigs(response);
        });
      }
      if (formSaDetail.productBuyIds) {
        Product.searchAll({
          productIds: formSaDetail.productBuyIds,
          isActive: true
        }).then(response => {
          if (response && response.data) {
            const products = response.data;
            setExpandKeysProduct(products.map(item => `${item.productId}`));
            formRef.current?.setFieldsValue({
              productBuyIds: products.map(item => ({value: item.productId, label: item.codeOrName}))
            });
            setProductBuyIds(products.map(item => item.productId).join(","));
          }
        });
      }
      if (isNeedProductFg(formSaDetail.paymentMethodId) && formSaDetail.productFgIds) {
        Product.get(formSaDetail.productFgIds).then(response => {
          if (response && response.data) {
            formRef.current?.setFieldsValue({
              productFgIds: {value: response.data.productId, label: response.data.codeOrName}
            });
          }
        });
      }
    }
  }, [formSaDetail]);

  useEffect(() => {
    if (ecFieldConfigs && formSaDetail) {
      Object.keys(ecFieldConfigs).map(key => {
        if (ecFieldConfigs[key].contain) {
          if (ecFields[key] && ecFields[key].set) {
            ecFields[key].set(formSaDetail, formRef);
          } else if (!wdiCore.Object.IsNullOrUndefined(formSaDetail[key])) {
            formRef.current?.setFieldsValue({[key]: formSaDetail[key]});
          }
        }
      });

      setProductConfig(getEcProductConfig(ecFieldConfigs));
    }
  }, [ecFieldConfigs, formSaDetail]);

  const calculateAmount = () => {
    const fieldsValues = {
      amount: null,
    };
    const {
      revenuePosForecast,
      executionRateForecast,
      roiForecast,
    } = formRef.current?.getFieldsValue();
    if (!wdiCore.Object.IsNullOrUndefined(revenuePosForecast)
      && !wdiCore.Object.IsNullOrUndefined(executionRateForecast)
      && !wdiCore.Object.IsNullOrUndefined(roiForecast)) {
      fieldsValues.amount = wdiCore.Number.ToNumber(revenuePosForecast * executionRateForecast * roiForecast, 2);
    }
    formRef.current?.setFieldsValue(fieldsValues);
  }

  return (
    <>
      <WdiModalForm
        {...HorzLayoutOpts}
        formRef={formRef}
        initialValues={{executionRateForecast: 1}}
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose?.()
          },
        }}
        onFinish={async (values) => {
          const ecFieldValues = getEcFieldsValue(ecFieldConfigs, ecFields, values);
          const entity: API.FormSaDetail = {
            paymentMethodId: values.paymentMethodId,
            amount: values.amount,
            remark: values.remark
          };

          entity.productBuyIds = WdiSelectFormat.getvalue(values.productBuyIds);
          if (isNeedProductFg(paymentMethodId)) {
            entity.productFgIds = WdiSelectFormat.getvalue(values.productFgIds);
          }
          entity.companyCode = WdiSelectFormat.getvalue(values.companyCode);

          if (wdiCore.Object.IsNullOrUndefined(values.amount)) {
            message.error("申请金额不能为空!");
            return;
          }
          if (values.activityDate && values.activityDate.length == 2) {
            entity.activityStartDate = moment(values.activityDate[0]).format('YYYY-MM-DD');
            entity.activityEndDate = moment(values.activityDate[1]).format('YYYY-MM-DD');
          }
          if (values.supplyDate && values.supplyDate.length == 2) {
            entity.supplyStartDate = moment(values.supplyDate[0]).format('YYYY-MM-DD');
            entity.supplyEndDate = moment(values.supplyDate[1]).format('YYYY-MM-DD');
          }

          const response = await FormSa.Buttons.validateDetail({
            rowIndex: rowIndex,
            formSa: {...formSa},
            form: {...props.data.form},
            formSaDetail: Object.assign({}, getDetailPrevData(formSaDetail), entity, ecFieldValues),
            formSaDetails: rows
          });
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
            return;
          }
          if (props.onSave) {
            response.data = Object.assign({}, {rowIndex: rowIndex}, response.data);
            props.onSave(response);
          }
        }}
      >
        {buildFormItem("formSaDetailIdOriginal")}
        {buildFormItem("soldToName")}
        {buildEcFormItem("shopId", {fieldConfig: ecFieldConfigs?.["shopId"], soldToCode: formSaDetail.soldToCode})}
        {buildFormItem("activityDate")}
        {buildFormItem("supplyDate")}

        <Form.Item
          name="productBuyIds" label="产品别"
          rules={[{required: productConfig?.fieldCfg.req, message: '产品别不能为空!'}]}>
          <WdiTreeSelect {...{
            multiple: true,
            placeholder: "请选择产品别",
            defaultExpandKeys: expandKeysProduct,
            dataLoading: async (params) => {
              const response = await Product.searchAll(
                Object.assign({
                  productLevels: PRODUCT_FULL_LEVELS.filter(m => (m <= Number(max(productConfig?.levels)))).join(),
                  budgetProjectId: formSa.budgetProjectId,
                  isActive: true,
                  withPermissions: true,
                }, params)
              );
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                textField: "codeOrName",
                valueField: "productId",
                id: "productId",
                pId: "parentId",
                level: "productLevel",
                disabledLevel: PRODUCT_FULL_LEVELS.filter(m => !productConfig?.levels.includes(m))
              }, response.data);
              return {treeData, dict};
            },
            onExSelect: (value: any, node: any, dict: any) => {
              const values = formRef.current?.getFieldValue("productBuyIds");
              const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
              formRef.current?.setFieldsValue({productBuyIds: rtv});
              setProductBuyIds(WdiSelectFormat.getvalue(rtv));
            },
            reloadKey: `${productConfig?.levels.join()}${formSaDetail.soldToCode}`
          }} />
        </Form.Item>

        {buildEcFormItem("ip", {fieldConfig: ecFieldConfigs?.["ip"], productIds: productBuyIds})}

        <Form.Item
          name="paymentMethodId" label="支付方式"
          rules={[{required: true, message: '支付方式不能为空!'}]}>
          <WdiSelect {...{
            placeholder: "请选择支付方式",
            options: pmOpts,
            onChange: (value) => {
              handlePaymentMethodChange(value);
            }
          }} />
        </Form.Item>
        {showCompany(paymentMethodId) && (
          <Form.Item
            name="companyCode" label="付款公司"
            rules={[{required: true, message: '付款公司不能为空!'}]}
          >
            <WdiSelect
              {...{
                placeholder: '请选择公司',
                showSearch: true,
                dataLoading: async (params) => {
                  const response = await Company.search(Object.assign({
                    isActive: true,
                  }, params));
                  return response?.data?.map(item => ({value: item.companyCode, label: item.codeOrName}));
                },
                reloadKey: paymentMethodId,
              }}
            />
          </Form.Item>
        )}

        {buildFormItem("productFgIds", {
          paymentMethodId: paymentMethodId,
          productFgIds: formSaDetail?.productFgIds,
          budgetProjectId: formSa.budgetProjectId
        })}

        <Form.Item
          name="revenuePosForecast" label="预估POS销售额"
          hidden={!ecFieldConfigs?.["revenuePosForecast"].contain}
          rules={[{required: ecFieldConfigs?.["revenuePosForecast"].req, message: '预估POS销售额不能为空!'}]}>
          <WdiInputNumber min={0} onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item
          name="roiForecast" label="预计费比"
          hidden={!ecFieldConfigs?.["roiForecast"].contain}
          rules={[{required: ecFieldConfigs?.["roiForecast"].req, message: '预计费比不能为空!'}]}>
          <WdiInputNumber min={0} max={100} format="p" onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item
          name="executionRateForecast" label="转化率"
          hidden={!ecFieldConfigs?.["executionRateForecast"].contain}
          rules={[{required: ecFieldConfigs?.["executionRateForecast"].req, message: '转化率不能为空!'}]}>
          <WdiInputNumber min={0} max={100} format="p" onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>

        {buildEcFormItem("activitySubjectId", {fieldConfig: ecFieldConfigs?.["activitySubjectId"]})}
        {buildEcFormItem("displayTypeIds", {fieldConfig: ecFieldConfigs?.["displayTypeIds"]})}
        {buildEcFormItem("displayQuantity", {fieldConfig: ecFieldConfigs?.["displayQuantity"]})}
        {buildEcFormItem("displayArea", {fieldConfig: ecFieldConfigs?.["displayArea"]})}
        {buildEcFormItem("targetShopQuantity", {fieldConfig: ecFieldConfigs?.["targetShopQuantity"]})}
        {buildEcFormItem("priceSellinAfter", {fieldConfig: ecFieldConfigs?.["priceSellinAfter"]})}
        {buildEcFormItem("pricePosAfter", {fieldConfig: ecFieldConfigs?.["pricePosAfter"]})}
        {buildEcFormItem("quantitySellinForecast", {fieldConfig: ecFieldConfigs?.["quantitySellinForecast"]})}
        {buildEcFormItem("revenueSellinForecast", {fieldConfig: ecFieldConfigs?.["revenueSellinForecast"]})}
        {buildEcFormItem("quantityPosForecast", {fieldConfig: ecFieldConfigs?.["quantityPosForecast"]})}

        <Form.Item name="amount" label="申请金额" rules={[{required: true, message: '申请金额不能为空!'}]}>
          <WdiInputNumber readOnly/>
        </Form.Item>

        {buildFormItem("remark")}
        {buildFormItem("ecName")}
        {buildFormItem("revenueTypeName")}
        {buildFormItem("boName")}
      </WdiModalForm>
    </>
  );
}
export default DetailPosRevenueApp;
